import { IConstructorOptions } from "../../../Utilities";
import { DataEntityBase } from "./Base/DataEntityBase";
import { Models } from "./Base/Models";


export enum FeedbackRuleType {
    NewUser = 'NewUser',
    NewRelease = 'NewRelease',
    Standard = 'WaitStandard',
}

export enum FeedbackRulesProperties {

    newUserDays = '_newUserDays',
    newUserEntries = '_newUserEntries',
    newUserDaysEnd = '_newUserDaysEnd',

    newReleaseDays = '_newReleaseDays',
    newReleaseEntries = '_newReleaseEntries',
    newReleaseDaysEnd = '_newReleaseDaysEnd',

    waitDaysStandard = '_waitDaysStandard',
    waitDaysSelfhost = '_waitDaysSelfhost',
    waitDaysPublicPreview = '_waitDaysPublicPreview',

    feedbackDisabled = '_feedbackDisabled',

    feedbackTasks = '_feedbackTasks',

    type = '_type',
}


export class FeedbackRules extends DataEntityBase {

    public static get TypeName() { return Models.FeedbackRules; }

    public static CreateId() {
        return DataEntityBase.CreateId(FeedbackRules.TypeName, FeedbackRules.TypeName)
    };

    public static Create(options?: IConstructorOptions) {
        var retVal = new FeedbackRules(options);
        return retVal;
    }






    public get newUserDays(): number { return this[FeedbackRulesProperties.newUserDays]; }
    public set newUserDays(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newUserDays, value); }
    [FeedbackRulesProperties.newUserDays] = 7;

    public get newUserEntries(): number { return this[FeedbackRulesProperties.newUserEntries]; }
    public set newUserEntries(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newUserEntries, value); }
    [FeedbackRulesProperties.newUserEntries] = 3;

    public get newUserDaysEnd(): number { return this[FeedbackRulesProperties.newUserDaysEnd]; }
    public set newUserDaysEnd(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newUserDaysEnd, value); }
    [FeedbackRulesProperties.newUserDaysEnd] = 14;





    public get newReleaseDays(): number { return this[FeedbackRulesProperties.newReleaseDays]; }
    public set newReleaseDays(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newReleaseDays, value); }
    [FeedbackRulesProperties.newReleaseDays] = 5;

    public get newReleaseEntries(): number { return this[FeedbackRulesProperties.newReleaseEntries]; }
    public set newReleaseEntries(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newReleaseEntries, value); }
    [FeedbackRulesProperties.newReleaseEntries] = 3;

    public get newReleaseDaysEnd(): number { return this[FeedbackRulesProperties.newReleaseDaysEnd]; }
    public set newReleaseDaysEnd(value: number) { this.UpdateAndFire(FeedbackRulesProperties.newReleaseDaysEnd, value); }
    [FeedbackRulesProperties.newReleaseDaysEnd] = 14;





    public get waitDaysStandard(): number { return this[FeedbackRulesProperties.waitDaysStandard]; }
    public set waitDaysStandard(value: number) { this.UpdateAndFire(FeedbackRulesProperties.waitDaysStandard, value); }
    [FeedbackRulesProperties.waitDaysStandard] = 84;

    public get waitDaysPublicPreview(): number { return this[FeedbackRulesProperties.waitDaysPublicPreview]; }
    public set waitDaysPublicPreview(value: number) { this.UpdateAndFire(FeedbackRulesProperties.waitDaysPublicPreview, value); }
    [FeedbackRulesProperties.waitDaysPublicPreview] = 28;

    public get waitDaysSelfhost(): number { return this[FeedbackRulesProperties.waitDaysSelfhost]; }
    public set waitDaysSelfhost(value: number) { this.UpdateAndFire(FeedbackRulesProperties.waitDaysSelfhost, value); }
    [FeedbackRulesProperties.waitDaysSelfhost] = 14;





    public get feedbackDisabled(): boolean { return this[FeedbackRulesProperties.feedbackDisabled]; }
    public set feedbackDisabled(value: boolean) { this.UpdateAndFire(FeedbackRulesProperties.feedbackDisabled, value); }
    [FeedbackRulesProperties.feedbackDisabled] = false;

    public get feedbackTasks(): string[] { return this[FeedbackRulesProperties.feedbackTasks]; }
    public set feedbackTasks(value: string[]) { this.UpdateAndFire(FeedbackRulesProperties.feedbackTasks, value); }
    [FeedbackRulesProperties.feedbackTasks] = [
        'Planning your day',
        'Checking off your outcomes/tasks',
        'Reflecting on your day',
        'Reviewing your week',
        'Looking at your trends'
    ];



    public get type(): FeedbackRuleType { return this[FeedbackRulesProperties.type]; }
    public set type(value: FeedbackRuleType) { this.UpdateAndFire(FeedbackRulesProperties.type, value); }
    [FeedbackRulesProperties.type] = FeedbackRuleType.Standard;

















    protected constructor(options?: IConstructorOptions) {

        super(
            {
                typename: FeedbackRules.TypeName,
                serializationProperties: FeedbackRulesProperties,
                dateProperties: FeedbackRules.completableDateProperties,
                jsonProperties: FeedbackRules.completableJsonProperties
            });
        this.CompleteConstruction(options);
    }

    private static completableDateProperties: string[] = [
    ];


    private static completableJsonProperties: string[] = [
        FeedbackRulesProperties.feedbackTasks
    ];
}